<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               v-if="reWrite"
               :search.sync="search"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               :before-close="beforeClose"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
          <template slot="menuLeft">
            <el-button type="success" plain size="small" icon="el-icon-upload2" @click="importForm"
              >导入
            </el-button>
            <wq-exportData :moduleType="102" @exportExcel="exportExcel"></wq-exportData>

          </template>
           <template slot="menuRight">
             <showHidden :column.sync="option.column" :moduleType="102" ></showHidden>
           </template>
      <template slot="fileListForm" slot-scope="scope">
        <vUpload :max="5242880" :limit="10" :fileList.sync="form.fileList" :disabled="form.flag == 'view'"></vUpload>
      </template>
    </avue-crud>


    <el-dialog title="导出数据" :visible.sync="exportExcelSelectionBoxFlag" append-to-body width="30%"
               :close-on-click-modal="false">
        <div style="text-align:center;padding:2rem 0;">
          <el-radio v-model="exportExcelSelectionRadio" label="1">导出全部数据</el-radio>
          <el-radio v-model="exportExcelSelectionRadio" label="2">导出已选数据</el-radio>
        </div>
        <div style="text-align:center;">
          <el-button type="primary" @click="exportExcel">确定</el-button>
          <el-button type="info" @click="exportExcelSelectionBoxFlag=false">取消</el-button>
        </div>
    </el-dialog>

    <el-dialog
      title="供应商管理数据导入"
      append-to-body
      :visible.sync="showUploadDialog"
      width="555px"
      accept="vnd.ms-excel"
      :close-on-click-modal="false"
    >
      <avue-form
        id="contractFileListStyle20210419"
        :option="excelOption"
        v-model="upload"
        :upload-after="uploadAfter"
        :upload-before="uploadBefore"
        @on-success="test"
      >
        <template slot-scope="scope" slot="downloadAction">
            模板下载:
            <el-button type="primary" size="small" icon="el-icon-download" @click="exportDemoExcel">
              模板下载
            </el-button>
            <!-- <el-button @click="tip">自定义按钮</el-button> -->
        </template>
      </avue-form>
    </el-dialog>

  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update,} from "@/api/crmedical/partner/partner";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {getProjectDict} from "@/api/crmedical/project-dictionary/project-dictionary";
  import { Base64 } from 'js-base64';
  import settings from '@/config/vd-settings';
  import { getToken } from '@/util/auth';
  import vUpload from "@/views/components/v-upload";
  import showHidden from "@/components/showHidden/showHidden";
  export default {
    components: {
      vUpload,showHidden
    },
    data() {
      return {
        search:{},
        searchForm:{},
        projectFlag: true,
        form: {
          flag:'',
          projectId: ""},
        query: {
          project: '',
          projectId: '',
          attachList: [],
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        reWrite: false,
        selectionList: [],
        projectList: [],
        operateType: '',
        attachIdList:[],
        attachList: [],
        temProjectId: '',
        firstDisplayFlag: false,
        option: {
          defaultSort:{
            prop:'sortIndex',order:'descending'
          },
          height: 'auto',
          searchShow: true,
          searchMenuSpan: 6,
          //calcHeight: 30,
          align: 'center',
          indexLabel: '序号',
          tip: false,
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          refreshBtn: false,
          labelWidth: 150,
          columnBtn:false,
          dialogClickModal: false,
          column: [

            {
              order:19,
              searchOrder:19,
              showColumn:true,
              label: '项目名称',
              type: 'tree',
              span: 12,
              hide: false,
              searchClearable:false,
              dicData: [],
              viewDisplay: true,
              cascaderItem: ['type'],
              cascaderChange: true,
              minWidth: 120,
              search: true,
              display: true,
              props: {
                label: "name",
                value: "id",
              },
              prop: 'projectId',
              required: true,
              rules: [
                {
                  required: true,
                  message: '请选择项目名称'
                }
              ]
            },
             {
              order:18,
              searchOrder:18,
              showColumn:true,
              type: 'select',
              label: '供应商类型',
              searchLabelWidth: 100,
              width: 100,
              search: true,
              hide: false,
              editDisplay: true,
              dataType: 'string',
              dicData: [],
              dicUrl: "/api/v4ward/projectDict/dictionary?code=project_partner_type&projectId={{key}}",
              span: 12,
              props: {
                label: 'dictValue',
                value: 'dictKey',
                disabled: 'disabled',
              },
              prop: 'type',
              required: true,
              rules: [
                {
                  required: true,
                  message: '请选择供应商类型'
                }
              ]
            },
            {
              order:17,
              searchOrder:17,
              showColumn:true,
              type: 'input',
              label: '供应商名称',
              span: 12,
              searchLabelWidth: 100,
              showWordLimit: true,
              search: true,
              display: true,
              maxlength: 50,
              width: 150,
              prop: 'name',
              required: true,
              rules: [
                {
                  required: true,
                  message: '请选择供应商名称'
                }
              ]
            },



            {
              order:16,
              showColumn:true,
              type: 'select',
              label: '供应商等级',
              searchLabelWidth: 100,
              search: false,
              width: 100,
              dataType: 'string',
              dicData: [],
              span: 12,
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              prop: 'level',
              rules: [
                {
                  required: true,
                  message: '请选择供应商等级'
                }
              ],
              required: true
            },
            {
              order:15,
              showColumn:true,
              type: 'input',
              label: '联系人',
              showWordLimit: true,
              span: 12,

              display: true,
              prop: 'contactName',
              maxlength: 20,
              rules: [
                {
                  required: true,
                  message: '请输入联系人'
                },
                {pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '格式错误'},
              ]
            },
            {
              order:14,
              showColumn:true,
              type: 'input',
              label: '联系电话',
              span: 12,
              display: true,
              prop: 'contactTel',
              maxlength: 20,
              showWordLimit: true,
              rules: [
                {
                  required: true,
                  message: '请输入联系电话'
                },
                 // {pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/, message: '请输入正确得座机或手机号码！'},


              ]
            },
            {order:13,
              title: '分割线',
              component: 'el-divider',
              span: 24,
              tips: '看我：自定义属性怎么用？',
              labelWidth: '100px',
              params: {
                contentPosition: 'left'
              },
              prop: '1603791711523_95908',
              hide: true,
            },
            {
              order:12,
              showColumn:true,
              type: 'input',
              label: '税号',
              hide: true,
              span: 12,
              maxlength: 30,
              showWordLimit: true,
              display: true,
              prop: 'taxNo',
              rules: [
                {
                  required: true,
                  message: '请输入税号'
                }
              ]
            },
            {
              order:11,
              showColumn:true,
              type: 'input',
              label: '注册地址',
              span: 12,
              maxlength: 40,
              showWordLimit: true,
              display: true,
              prop: 'addr',
              rules: [
                {
                  required: true,
                  message: '请输入注册地址'
                }
              ],
            },
            {
              order:10,
              showColumn:true,
              type: 'input',
              label: '开户银行',
              span: 12,
              display: true,
              maxlength: 20,
              showWordLimit: true,
              hide: true,
              prop: 'bankName',
              rules: [
                {
                  required: true,
                  message: '请输入开户银行'
                },
              ],
            },
            {
              order:9,
              showColumn:true,
              type: 'input',
              label: '银行账户',
              span: 12,
              display: true,
              hide: true,
              showWordLimit: true,
              maxlength: 30,
              prop: 'bankAccount',
              rules: [
                {
                  required: true,
                  message: '请输入银行账户'
                },
                {pattern: /^([1-9]{1})(\d{7,29})$/, message: '请输入8位至30位的正确银行账号！'},
              ],
            },
            {
              order:8,
              showColumn:true,
              type: 'input',
              label: '法定代理人',
              span: 12,
              display: true,
              showWordLimit: true,
              hide: true,
              prop: 'legalAgent',
              maxlength: 20,
              rules: [
                {
                  required: true,
                  message: '请输入法定代理人'
                },
                {pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '格式错误'},
              ],
              required: true
            },
            {
              order:7,
              showColumn:true,
              type: 'input',
              label: '法人身份证号',
              span: 12,
              display: true,
              hide: true,
              maxlength: 20,
              showWordLimit: true,
              prop: 'identityCardNo',
              rules: [
                {
                  required: false,
                  message: '请输入法人身份证号'
                },
                {pattern: /^\d{15}|\d{18}$/, message: '格式错误'},

              ]
            },
            {
              order:6,
              showColumn:true,
              type: 'input',
              label: '邮政编码',
              span: 12,
              display: true,
              maxlength: 20,
              showWordLimit: true,
              hide: true,
              prop: 'postCode',
              rules: [
                {
                  required: false,
                  message: '请输入邮政编码'
                },
                //{pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: '格式错误'},

              ]
            },
            {
              order:5,
              showColumn:true,
              type: 'input',
              label: '公司电话',
              span: 12,
              display: true,
              hide: true,
              maxlength: 20,
              showWordLimit: true,
              prop: 'officeTel',
              rules: [
                {
                  required: false,
                  message: '请输入公司电话'
                },
                {pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/, message: '请输入正确得座机或手机号码！'},

              ]
            },
            {
              order:4,
              showColumn:true,
              type: 'input',
              label: '公司传真',
              span: 12,
              hide: true,
              display: true,
              maxlength: 20,
              showWordLimit: true,
              prop: 'fax',
              rules: [
                {
                  required: false,
                  message: '请输入公司传值'
                },
                //{pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: '格式错误'},

              ]
            },
            {
              order:3,
              showColumn:true,
              type: 'input',
              label: '公司邮箱',
              span: 12,
              hide: true,
              display: true,
              maxlength: 20,
              showWordLimit: true,
              prop: 'email',
              rules: [
                {
                  required: false,
                  message: '请输入公司邮箱',
                },
                {pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '请输入正确邮箱格式！'},
              ]
            },
            {
              order:2,
              title: '分割线',
              component: 'el-divider',
              span: 24,
              tips: '看我：自定义属性怎么用？',
              labelWidth: '100px',
              params: {
                contentPosition: 'left'
              },
              prop: '1603793907779_59894',
              //label: '相关附件',
              hide: true,
            },
            {
              order:1,
              label: '电子附件',
              span: 24,
              hide: true,
              formslot: true,
              prop: 'fileList',
            }
          ],
        },
        typeList: [],
        levelList: [],
        headers:{},
        data: [],

        exportExcelSelectionRadio:'1',
        showUploadDialog: false,
        exportExcelSelectionBoxFlag:false,
        contractIds:'',


      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            // action: '/api/v4ward/contract/imporContract',
            action: '/api/v4ward/partner/imporSupplier',
            data:{
              // projectId:'123',
            }
          },
          {
            label: '模板下载',
            prop:'downloadAction',
            formslot:true,
          }
        ],
      },

      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.partner_add, false),
          viewBtn: this.vaildData(this.permission.partner_view, false),
          delBtn: this.vaildData(this.permission.partner_delete, false),
          editBtn: this.vaildData(this.permission.partner_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    watch: {
      "form.projectId": function () {
        this.query.project = this.form.projectId;
        //this.form.type = "";
        this.form.level = "";
        let projectIdTem = this.form.projectId;
        if (this.vdui.isNotEmpty(projectIdTem)) {
          //this.loadTypeSelections(this.form.projectId);
          this.loadLevelSelections(this.form.projectId);
        }
      },
      "option.column"(){

        this.$refs.crud.selectClear();
        this.contractIds = "";
        this.search = this.searchForm;
      },
      "search"(val,oldVal){
        console.log(111111111111)
        console.log(val==oldVal)
        // if(){

        // }
      }

    },

    created() {

      getProjectList().then((data) => {
        this.headers['Authorization'] = `Basic ${Base64.encode(
          `${settings.clientId}:${settings.clientSecret}`
        )}`;
        // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        this.headers['Blade-Auth'] = 'bearer ' + getToken();

        this.projectList = data.data;

        if (this.projectList.length > 0) {
          var projectColumn = this.findObject(this.option.column, 'projectId');
          projectColumn.dicData = data.data;
          projectColumn.searchValue = this.projectList[0].id;
          this.query.projectId = this.projectList[0].id;
          this.temProjectId = this.projectList[0].id;
          this.form.projectId = this.temProjectId;
          // this.loadTypeSelections(this.form.projectId);
           //this.loadLevelSelections(this.form.projectId);
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },
    mounted(){

      this.columnFormOption2 = JSON.parse(JSON.stringify(this.option));
      console.log(this.$refs.crud)
    },
    methods: {
      //获取设置显隐配置
      getTableConfig(config){
          setTimeout(()=>{
            this.$nextTick(()=>{
                    let configColumn = config.split(",");
                    let topColumn = [];
                    let downColumn = [];
                    this.option.column.forEach(ele=>{
                      if(ele.showColumn){
                        let columnIndex = configColumn.indexOf(ele.prop);
                        if(columnIndex>-1){
                          topColumn[columnIndex] = ele;
                        }else{
                          downColumn.push(ele);
                        }
                      }
                    });
                  let allColumn = topColumn.concat(downColumn);
                  this.option.column = allColumn;
            })
          })

      },
    //导出模板
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出设备设施模版
        window.open(
          `/api/v4ward/partner/supplierDemoExcel?${
            this.website.tokenHeader
          }=${getToken()}&projectId=` + this.query.projectId
        );
      });
    },
    uploadBefore(file, done, loading,column) {
      console.log(file,column)
      //如果你想修改file文件,由于上传的file是只读文件，必须复制新的file才可以修改名字，完后赋值到done函数里,如果不修改的话直接写done()即可
      // var newFile = new File([file], '1234', { type: file.type });
      column.data.projectId = this.query.projectId;
      done(file,column);
      // this.$message.success('上传前的方法')
    },
    uploadAfter(res, done) {
      if (!res) {
        this.$message({
          message: '上传成功！',
          type: 'success',
        });
        this.showUploadDialog = false;
        this.onLoad();
      }
      done();
    },
    //导出合同台账数据
    exportExcel(data) {

      let saveIds = data.exportExcelSelectionRadio=='1'?'':this.contractIds;
      console.log(saveIds)
      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }

      this.$confirm('是否导出数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        let projectId = '';
        if (this.searchForm.projectId) {
          projectId = this.searchForm.projectId;
        }
        // 合同类型
        let type = '';
        if (this.searchForm.type) {
          type = this.searchForm.type || '';
        }
        // 名称
        let name = '';
        if (this.searchForm.name) {
          name = this.searchForm.name || '';
        }

        // $children[0].searchForm
        if(data.exportExcelSelectionRadio == 2 ){
          window.open(
            `/api/v4ward/personal/config/export/default/supplierExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&projectId=${projectId}&saveIds=${saveIds}`
          );
        }else{

          window.open(
            `/api/v4ward/personal/config/export/default/supplierExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&projectId=${projectId}&type=${type}&name=${name}`
          );
        }

      });
    },
    //导入数据
    importForm() {
      console.log('打开上传表单...');
      this.showUploadDialog = true;
    },

    exportExcelSelection(){
      this.exportExcelSelectionBoxFlag = true;
    },
      //加载
      loadTypeSelections(projectId) {
        if (typeof projectId === 'undefined') {
          return;
        }
        getProjectDict({projectId: projectId, code: "project_partner_type"}).then((res) => {
          console.log(res)
          if (this.operateType === 'add') {
            this.form.type = null;
          }
          const column = this.findObject(this.option.column, 'type');
          column.dicData = res.data;
          this.typeList = res.data;

        });
      },
      loadLevelSelections(projectId) {
        if (typeof projectId === 'undefined') {
          return;
        }
        getProjectDict({projectId: projectId, code: "project_partner_level"}).then((res) => {
          if (this.operateType === 'add') {
            this.form.level = null;
          }
          const column = this.findObject(this.option.column, 'level');
          column.dicData = res.data;
          if(column.dicData.length==0){
            column.dicData.push('');
          }

        });
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          //this.$refs.form.resetForm();
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      //自定义清空表单
      emptyForm() {
        this.form.id='';
        this.form.projectId = '';
        this.form.name = '';
        this.form.type = '';
        this.form.level = '';
        this.form.contactName = '';
        this.form.contactTel = '';
        this.form.taxNo = '';
        this.form.addr = '';
        this.form.bankName = '';
        this.form.bankAccount = '';
        this.form.legalAgent = '';
        this.form.identityCardNo = '';
        this.form.postCode ='';
        this.form.officeTel = '';
        this.form.fax = '';
        this.form.email = '';
        this.form.fileList=[];
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          //this.$refs.form.resetForm();
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeClose(done,type){
        this.emptyForm();
        this.attachIdList = [];
        this.form = [];
        this.fileDisabled = false;
        done();
      },
      beforeOpen(done, type) {

        this.viewFlag = false;
        this.form.flag = type;
        if(type === 'view'){
          this.viewFlag = true;
        }
        if(type=="add"){
          this.form.fileList = []
        }
        if (["edit", "view"].includes(type)) {
          if (["view"].includes(type)) {
            console.log('查看')
            this.fileDisabled = true;
          }


          this.editViewDetail();

        }


        done();
      },
      async editViewDetail(){
        await getDetail({id: this.form.id}).then(({data}) => {
              this.form = data;

            });

            await  getProjectDict({projectId: this.form.projectId, code: "project_partner_type"}).then((res) => {
              if (this.operateType === 'add') {
                this.form.type = null;
              }
              const column1 = this.findObject(this.option.column, 'type');
              column1.dicData = res.data;
              //this.typeList = res.data;
              column1.dicData.forEach((e) => {
                if(e.dictKey==this.form.type){
                  document
                    .querySelector('div[id*=el-collapse-content] > div > div > div:nth-child(3) > div > div > div > div.el-input.el-input--small.el-input--suffix > input[placeholder="请选择 供应商类型"]')
                    .value = e.dictValue;
                }

              });

            });

            await getProjectDict({projectId: this.form.projectId, code: "project_partner_level"}).then((res) => {
              if (this.operateType === 'add') {
                this.form.level = null;
              }
              const column2 = this.findObject(this.option.column, 'level');
              column2.dicData = res.data;
              //this.levelList = res.data;
              column2.dicData.forEach((e) => {
                if(e.dictKey==this.form.level){
                  document
                    .querySelector('div[id*=el-collapse-content] > div > div > div:nth-child(4) > div > div > div > div.el-input.el-input--small.el-input--suffix > input[placeholder="请选择 供应商等级"]')
                    .value = e.dictValue;
                }

              });

            });
      },
      searchReset() {
        this.query = {};
        this.query.projectId = this.projectList[0].id;
        this.firstDisplayFlag = true;
        this.onLoad();
      },
      searchChange(params, done) {

        if (this.vdui.isEmpty(params)) {
          this.query.projectId = this.projectList[0].id;
        } else {
          this.query = params;
        }
        /*getProjectDict({projectId: params.projectId, code: "project_partner_type"}).then((res) => {
          const column = this.findObject(this.option.column, 'type');
          column.dicData = res.data;

        });*/
        getProjectDict({projectId: params.projectId, code: "project_partner_level"}).then((res) => {
          const column = this.findObject(this.option.column, 'level');
          column.dicData = res.data;
        });
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      // selectionChange(list) {
      //   this.selectionList = list;
      // },
      selectionChange(val){
        console.log(val);
        let Ids = [];
        val.forEach(element => {
          Ids.push(element.id);
        });
        this.contractIds = Ids.join(',');
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      async onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.searchForm = JSON.parse(JSON.stringify(this.query));
        await getList(
              Object.assign(
                {current: page.currentPage, size: page.pageSize},
                this.query
              )
            ).then(({data}) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
              if (this.firstDisplayFlag) {
                let ent = document.querySelector('input[placeholder="项目名称"]');
                ent.value = this.projectList[0].name;
                this.query.projectId = this.projectList[0].id;
                //关闭默然显示，重刷页面时才开启默认显示
                this.firstDisplayFlag = false;
              }
            });

      },
    }
  };
</script>

<style scoped>
  ::v-deep .avue-crud .el-input--small input, .avue-form .el-input--small input {
    padding-right: 65px;
  }
</style>
